import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'core/libs/helmet';

function Smi24({ id, height }) {
  useEffect(() => {
    if (!process.env.BROWSER_RUNTIME) return;

    (window.smiq = window.smiq || []).push({});
  }, [id]);

  return (
    <>
      <Helmet>
        <script async src='https://jsn.24smi.net/smi.js' />
      </Helmet>
      <div
        className='smi24__informer smi24__auto'
        data-smi-blockid={id}
        style={{ minHeight: height }}
      />
    </>
  );
}

Smi24.propTypes = {
  id: PropTypes.number.isRequired,
  height: PropTypes.number,
};

export default Smi24;
